enum BookingFlow {
  CarPickerVehicleAvailability = 'car_picker_vehicles_displayed',
  CheckoutChangeCarButtonClicked = 'checkout:change_car_button:clicked',
  CheckoutChangeCarModalSeeDetailsButtonClicked = 'checkout:change_car_modal:see_details_button:clicked',
  CheckoutChangeCarDialogCarButtonClicked = 'checkout:change_car_dialog:car_button:clicked',
  CheckoutBookButtonClick = 'checkout:booking:clicked',
  CheckoutOrderPlaced = 'checkout:booking:order_placed',
  CheckoutOrderFailed = 'checkout:booking:error',
  CheckoutBookingSuccess = 'checkout:booking:success',
  CheckoutFirstBookingSuccess = 'First Booking',
  CheckoutRepeatedBookingSuccess = 'Repeated Booking',
  CheckoutPriceDetailsClick = 'checkout:price_details_button:clicked',
  CheckoutAirportInstructionsClick = 'checkout:airport_instructions:clicked',
  CheckoutMinimumAgeRequirementClick = 'checkout:minimum_age_requirement:clicked',
  CheckoutCancellationPolicyClicked = 'checkout:cancellation_policy:clicked',
  CheckoutPromoButtonClicked = 'checkout:promo_button:clicked',
  CheckoutApplyPromoButtonClicked = 'checkout:apply_promo_button:clicked',
  CheckoutApplyPromoSuccess = 'checkout:apply_promo:success',
  CheckoutApplyPromoError = 'checkout:apply_promo:error',
  CheckoutViewContractButtonClicked = 'checkout:view_contract_button:clicked',
  CoverageDamageDetailsClicked = 'checkout:damage_details_button:clicked',
  CoverageLiabilityClicked = 'checkout:liability_details:clicked',
  CoverageDamageToggled = 'checkout:damage_button:toggled',
  CoverageLiabilityToggled = 'checkout:liability_button:toggled',
  PickUpProcessInstructionsClicked = 'checkout:pick_up_instructions:clicked',
  CheckoutAddPaymentSuccess = 'checkout:add_payment:success',
  CheckoutAddPaymentError = 'checkout:add_payment:error',
  RefineAddressDialogDismissed = 'Refine Address Dialog Dismissed',
  RefineAddressDialogSubmitted = 'Refine Address Dialog Submitted',
  RefineAddressDialogShown = 'Refine Address Dialog Shown',
  InvalidAddressWarningClicked = 'Invalid Address Warning Clicked',
  // BookingFlowV2
  SearchBarClicked = 'Search Bar Clicked',
  SearchAddressType = 'Search Address Type',
  SearchAddressSubmitted = 'Search Address Submitted',
  SearchDateSubmitted = 'Search Date Submitted',
  SearchSubmitted = 'Search Submitted',
  CarPickerVehiclesDisplayed = 'Car Picker Vehicles Displayed',
  CarPickerSubmitted = 'Car Picker Submitted',
  CarPickerSoldOutPageViewed = 'Car Picker Sold Out Page Viewed',
  CarPickerSoldOutCTAClicked = 'Car Picker Sold Out CTA Clicked',
  FleetStandardsClicked = 'Fleet Standards Clicked',
  TransparentFeesClicked = 'Transparent Fees Clicked',
  CarPickerCarDetailsOpened = 'Car Picker Car Details Opened',
  CarPickerErrorCardViewed = 'Car Picker Error Card Viewed',
  CarPickerErrorCardCTAClicked = 'Car Picker Error Card CTA Clicked',
}

enum GuestCheckout {
  AppDownloadClick = 'guest_checkout:app_download:clicked',
  ResendEmailClick = 'guest_checkout:resend_email:clicked',
  BookingAndPayClicked = 'guest_checkout:book_and_pay:clicked',
  BookingError = 'guest_checkout:booking:error',
  FirstNameEntered = 'guest_checkout:first_name:entered',
  LastNameEntered = 'guest_checkout:last_name:entered',
  PhoneNumberEntered = 'guest_checkout:phone_number:entered',
  EmailEntered = 'guest_checkout:email:entered',
  ConfirmEmailEntered = 'guest_checkout:confirm_email:entered',
  CardNumberEntered = 'guest_checkout:card_number:entered',
  CardExpiryEntered = 'guest_checkout:expiry:entered',
  CardCvvEntered = 'guest_checkout:cvv:entered',
  CardZipCodeEntered = 'guest_checkout:zip_code:entered',
}

enum Subscription {
  BreadcrumbsWhereAndWhenClick = 'breadcrumbs:where_and_when:clicked',
  BreadcrumbsChooseCarClick = 'breadcrumbs:choose_a_car:clicked',
  MainSearchSubmit = 'main_search:subscription_search:submitted',
  TeslaSearchSubmit = 'tesla_search:subscription_search:submitted',
  CheckoutMonthsOptionClick = 'sub_checkout:months_option:clicked',
  CheckoutMilesOptionClick = 'sub_checkout:miles_option:clicked',
  CheckoutLiabilityOptionClick = 'sub_checkout:liability_option:clicked',
  TripDetailsChangeDateClick = 'sub_trip:change_date_button:clicked',
  CheckoutSeeGalleyButtonClick = 'sub_checkout:car_gallery_button:clicked',
  CheckoutBookingError = 'sub_checkout:booking:error',
  CheckoutBookingSuccess = 'sub_checkout:booking:success',
  CheckoutBookButtonClick = 'sub_checkout:book_button:clicked',
  CheckoutSoftCheckDialogClick = 'sub_checkout:soft_check_dialog:clicked',
  WaitListCtaClicked = 'subscription:waitlist_cta:click',
  ServiceAreaSelected = 'Subscription Service Area Selected',
}

enum BetterInstructionsEvents {
  LogInDownloadClicked = 'instructions_login_download_clicked',
  ScreenViewed = 'instructions_screen_viewed',
  ModalInstructionsDisplayed = 'instructions_modal_displayed',
  SendDownloadLinkClicked = 'instructions_send_link_clicked',
}

enum SharedTripEvents {
  TripInviteCreateButtonClicked = 'user:create_trip_invite:clicked',
  TripInviteRemoveButtonClicked = 'user:remove_trip_invite:clicked',
  TripInviteAcceptClicked = 'user:trip_invite_accept:clicked',
  TripInviteSignupClicked = 'user:trip_invite_sign_up:clicked',
  TripInviteAddPersonalDataClicked = 'user:trip_invite_personal_data:clicked',
  TripAdditionalDriversDisplayed = 'user:additional_drivers:view',
  TripAddDriverClicked = 'user:add_driver:clicked',
  TripAddDriverPromptedToChatDisplayed = 'add_driver:prompted_to_chat',
  TripAddDriverStartChatButtonClicked = 'add_driver:start_chat_button:clicked',
  TripAddDriverStartChatWindowClosed = 'add_driver:start_chat_window:closed',
  TripShareInviteClicked = 'user:share_trip_invite:clicked',
  TripInviteWithdrawButtonClicked = 'user:withdraw_button:clicked',
  TripInviteRefuseButtonClicked = 'user:trip_invite_refused:clicked',
  TripInviteProfileFormSubmitted = 'Trip Invite Profile Form Submitted',
  TripInviteProfileFormSuccess = 'Trip Invite Profile Form Success',
  TripInviteAppVerificationClicked = 'Trip Invite App Verification Clicked',
}
enum InviteFriendsEvents {
  CopyCodeClicked = 'invite_friends:copy_code:clicked',
  ShareCodeError = 'invite_friends:share_code:error',
  ShareCodeClicked = 'invite_friends:share_code:clicked',
  EmailCodeSubmitted = 'invite_friends:email_code:submitted',
  EmailCodeSuccess = 'invite_friends:email_code:success',
  EmailCodeError = 'invite_friends:email_code:error',
  ReferCtaClicked = 'invite_friends:refer_cta:clicked',
  TripDetailsReferCtaClicked = 'trip_details:refer_cta:clicked',
}

enum Priceline {
  Error = 'priceline:error',
  SetPasswordClicked = 'priceline:set-password:click',
  Success = 'priceline:set-password:success',
  VerificationLinkClicked = 'user:verification_link:clicked',
  VerificationInstructionsClicked = 'user:verification_instructions:clicked',
  PricelineUseBrowserClicked = 'Priceline Use Browser Clicked',
}

enum Verification {
  VerificationInstructionsDisplayed = 'Verification Instructions Displayed',
  TripDetailsVerifyIdentificationClicked = 'Trip Details Verify Identification Clicked',
  TripDetailsUseAppClicked = 'Trip Details Use App Clicked',
  VerificationBrowserSuccess = 'Verification Browser Success',
  VerificationAppSuccess = 'Verification App Success',
  VerificationSubmitted = 'Verification Submitted',
  VerificationClosed = 'Verification Closed',
  VerificationErrored = 'Verification Errored',
}

enum CoverageBundles {
  TripCoverageEditClicked = 'trip_details:coverage_edit:clicked',
  TripCoverageCtaClicked = 'trip_details:coverage_cta:clicked',
  TripRoadsideAssistanceDialogDisplayed = 'trip_details:roadside_assistance_dialog:displayed',
  TripRoadsideAssistanceCtaClicked = 'trip_details:roadside_assistance_cta:clicked',
}

enum RentalAgreements {
  ViewRentalAgreement = 'rental_agreements:agreement:view',
  SignRentalAgreement = 'rental_agreements:agreement:signature',
  ViewVehicleDamage = 'rental_agreements:agreement:view_damage',
}

enum FrontendExperiments {
  ExperimentTriggered = 'experiment:triggered',
  ExperimentError = 'experiment:error',
  ExperimentEvent = 'experiment:event,',
}

enum UniqueRenters {
  PhoneVerificationOtpRequested = 'Phone Verification Otp Requested',
  PhoneVerificationOtpResent = 'Phone Verification Otp Resent',
  PhoneVerificationOtpSubmitted = 'Phone Verification Otp Submitted',
}

enum AirportInstructionsEvents {
  AirportCheckoutViewed = 'airport:checkout:viewed',
  AirportCheckoutDeliveryCTAClicked = 'airport:checkout:delivery_cta:clicked',
  AirportCheckoutReturnCTAClicked = 'airport:checkout:return_cta:clicked',
  AirportCheckoutDisclaimerViewed = 'airport:checkout:disclaimer_modal:viewed',
  AirportCheckoutDisclaimerBoxToggled = 'airport:checkout:disclaimer_box:toggled',
  AirportCheckoutDisclaimerCTAClicked = 'airport:checkout:disclaimer_cta:clicked',
  AirportTripViewed = 'airport:trip:viewed',
  AirportTripDeliveryCTAClicked = 'airport:trip:delivery_cta:clicked',
  AirportTripReturnCTAClicked = 'airport:trip:return_cta:clicked',
  AirportHowItWorksModalViewed = 'airport:how_it_works_modal:viewed',
  AirportHowItWorksCTAClicked = 'airport:how_it_works_modal_cta:clicked',
  AirportInstructionsArticleDisplayed = 'Airport Instructions Article Displayed',
}

enum SignInEvents {
  SignupError = 'user:signup:error',
  SignInSuccess = 'user:login:success',
  SigninError = 'user:login:error',
  SignOutSuccess = 'user:signout:success',
  SignOutError = 'user:signout:error',
}

enum SelfPickupEvents {
  SelfPickupDisplayed = 'PUL Getting The Vehicle Displayed',
  SelfPickupDeliveryClicked = 'PUL Delivery Clicked',
  SelfPickupDeliveryAddressSubmitted = 'PUL Delivery Address Submitted',
  SelfPickupDeliveryAddressCancelled = 'PUL Delivery Address Cancelled',
  SelfPickupPickupClicked = 'PUL Pickup Clicked',
  SelfPickupPickupAddressSubmitted = 'PUL Pickup Address Submitted',
  SelfPickupPickupAddressCancelled = 'PUL Pickup Address Cancelled',
  SelfPickupInstructionsClicked = 'PUL Instructions Clicked',
  SelfPickupCouponCodeBlocked = 'PUL Coupon Code Blocked',
}

enum LiveDataSocialProofEvents {
  LiveDataSocialProofDisplayed = 'LDSP Displayed',
  LiveDataSocialProofClicked = 'LDSP Clicked',
  LiveDataSocialProofDisabled = 'LDSP Disabled',
}

enum HandoverOutpostEvents {
  HandoverOutpostDisplayed = 'Handover Outpost Displayed',
  HandoverOutpostAccepted = 'Handover Outpost Accepted',
}

enum Search {
  CityTagSelected = 'Search City Tag Selected',
  CityTagDisplayed = 'Search City Tag Displayed',
  SuggestionClicked = 'Search Suggestion Clicked',
  RecentSearchClicked = 'Recent Search Clicked',
  VagueSearchRedirectedToLot = 'Vague Search Redirected To Lot',
}

enum Support {
  OpenUrl = 'Support Open URL',
  IntercomLaunched = 'Intercom Launched',
}

enum Auth0 {
  SigninRedirect = 'Auth0 Signin Redirect',
  SignoutRedirect = 'Auth0 Signout Redirect',
  SigninRedirectSuccess = 'Auth0 Signin Redirect Success',
  SignoutRedirectSuccess = 'Auth0 Signout Redirect Success',
}

enum EditTripEvents {
  ReschedulingFeeDisplayed = 'Rescheduling Fee Displayed',
  ReschedulingFeeDismissed = 'Rescheduling Fee Dismissed',
  ReschedulingFeeAccepted = 'Rescheduling Fee Accepted',
  EditTripPoliciesOpened = 'Edit Trip Policies Opened',
  EditTripPriceDifferenceOpened = 'Edit Trip Price Difference Opened',
}

enum TipEvents {
  TripDetailsTipDeliveryOptionClicked = 'trip_details:tip_delivery_option:clicked',
  TripDetailsTipReturnOptionClicked = 'trip_details:tip_return_option:clicked',
  TripDetailsTipCustomValuePressed = 'trip_details:tip_custom_value_pressed',
  TripDetailsTipCustomSubmitted = 'trip_details:tip_custom_submitted',
  TripDetailsTipSubmitted = 'trip_details:tip_submitted',
  CustomValuePressed = 'tipping:tip_custom_value_pressed',
  CustomSubmitted = 'tipping:tip_custom_submitted',
  Submitted = 'tipping:tip_submitted',
}

enum TripsDetailEvents {
  TripDetailClicked = 'trips:trip-detail:clicked',
  EditButtonClicked = 'trip_details:edit_button:clicked',
  EditTripViewed = 'edit_trip:viewed',
  EditTripClosed = 'edit_trip:closed',
  EditTripEditDatesSaved = 'edit_trip:edit_dates:saved',
  EditTripStartDateEditButtonClicked = 'edit_trip:start_date_edit_button:clicked',
  EditTripEndDateEditButtonClicked = 'edit_trip:end_date_edit_button:clicked',
  EditTripStartAddressPicked = 'edit_trip:start_address:picked',
  EditTripEndAddressPicked = 'edit_trip:end_address:picked',
  EditTripStartAddressEditClicked = 'edit_trip:start_address_edit:clicked',
  EditTripEndAddressEditClicked = 'edit_trip:end_address_edit:clicked',
  EditTripQuoteError = 'edit_trip:quote:error',
  EditTripSuccess = 'edit_trip:success',
  EditTripConfirmError = 'edit_trip:confirm:error',
  EditTripConfirmButtonClicked = 'edit_trip:confirm_button:clicked',
  EditTripStartChatButtonClicked = 'edit_trip:start_chat_button:clicked',
  EditTripStartChatWindowClosed = 'edit_trip:start_chat_window:closed',
  EditTripPromptedToChatDisplayed = 'edit_trip:prompted_to_chat',
}

enum CheckoutV2Events {
  // Checkout page events
  CheckoutContentLoading = 'Checkout Content Loading',
  CheckoutContentError = 'Checkout Content Error',
  CheckoutContentDisplayed = 'Checkout Content Displayed',
  CheckoutDisclaimerModalsDisplayed = 'Checkout Disclaimer Modals Displayed',
  CheckoutWelcomeBannerDisplayed = 'Checkout Welcome Banner Displayed',

  // Form submit events
  CheckoutFormSubmitted = 'Checkout Form Submitted',
  CheckoutFormError = 'Checkout Form Error',
  CheckoutFormSuccess = 'Checkout Form Success',
  CheckoutDriverUpdate = 'Checkout Driver Update',
  CheckoutDriverUpdateError = 'Checkout Driver Update Error',
  CheckoutDriverUpdateSuccess = 'Checkout Driver Update Success',
  CheckoutPaymentUpdate = 'Checkout Payment Update',
  CheckoutPaymentUpdateError = 'Checkout Payment Update Error',
  CheckoutPaymentUpdateSuccess = 'Checkout Payment Update Success',

  // Booking events
  BookingSubmitted = 'Booking Submitted',
  BookingError = 'Booking Error',
  BookingSuccess = 'Booking Success',
  OrderCompleted = 'Order Completed',

  // Driver section events
  DriverSigninClicked = 'Driver Signin Clicked',
  DriverInfoDisplayed = 'Driver Info Displayed',
  DriverFormDisplayed = 'Driver Form Displayed',
  YoungRenterToggled = 'Young Renter Toggled',

  // Trip section events
  // See SelfPickupEvents enum for remaining events
  CarClassEditCtaClicked = 'Car Class Edit CTA Clicked',
  CarClassChanged = 'Car Class Changed',
  TripEditStartCtaClicked = 'Trip Edit Start CTA Clicked',
  TripEditEndCtaClicked = 'Trip Edit End CTA Clicked',
  TripEditSubmitted = 'Trip Edit Submitted',
  DeliveryMethodSubmitted = 'Delivery Method Submitted',

  // Coverage section events
  // See CoverageBundles enum for remaining events
  UnlimitedMilesToggled = 'Unlimited Miles Toggled',

  // Protection section event
  CheckoutProtectionDisplayed = 'Checkout Protection Displayed',
  CheckoutProtectionPlanSelected = 'Checkout Protection Plan Selected',
  CheckoutProtectionDeclineDialogOpened = 'Protection Decline Dialog Opened',
  CheckoutProtectionDeclined = 'Checkout Protection Declined',
  CheckoutProtectionDeclineDialogUpgradeMinimum = 'Protection Decline Upgrade Minimum',
  CheckoutProtectionDisclaimerDialogOpened = 'Protection Disclaimer Opened',
  CheckoutProtectionDisclaimerDialogClosed = 'Protection Disclaimer Closed',
  CheckoutProtectionDisclaimerDialogButtonPressed = 'Protection Disclaimer Button Pressed',

  // Payment section events
  PaymentInfoDisplayed = 'Payment Info Displayed',
  PaymentFormDisplayed = 'Payment Form Displayed',
  PaymentFormValidated = 'Payment Form Validated',
  PaymentFormError = 'Payment Form Error',
  PaymentChangeCtaClicked = 'Payment Change CTA Clicked',
  PaymentChanged = 'Payment Changed',
  CreateStripeTokenSuccess = 'Create Stripe Token Success',
  CreateStripeTokenError = 'Create Stripe Token Error',
  PaymentMissingInBookingCart = 'Payment Missing In Booking Cart',
  PaymentAddedToBookingCart = 'Payment Added To Booking Cart',
  PaymentSubmitted = 'Payment Submitted',

  // Promo code events
  PromoCodeAddCtaClicked = 'Promo Code Add Cta Clicked',
  PromoCodeSubmitted = 'Promo Code Submitted',
  PromoCodeError = 'Promo Code Error',
  PromoCodeSuccess = 'Promo Code Success',

  // Additional Payment Methods
  AuthenticatedPaymentSetupSubmitted = 'Authenticated Payment Setup Submitted',
  AuthenticatedPaymentSetupSuccess = 'Authenticated Payment Setup Success',
  AuthenticatedPaymentSetupError = 'Authenticated Payment Setup Error',
  GuestPaymentSetupSubmitted = 'Guest Payment Setup Submitted',
  GuestPaymentSetupSuccess = 'Guest Payment Setup Success',
  GuestPaymentSetupError = 'Guest Payment Setup Error',
}

enum Navigation {
  NavSupportButtonClicked = 'nav:support_button:clicked',
  NavSignOutButtonClicked = 'nav:sign_out_button:clicked',
  NavSignUpButtonClicked = 'nav:sign_up_button:clicked',
  NavDownloadAppButtonClicked = 'nav:download_app_button:clicked',
  NavHowKyteWorksClicked = 'nav:how-kyte-works:clicked',
  NavTripsClicked = 'nav:trips:clicked',
  NavAccountClicked = 'nav:account:clicked',
  NavReferralClicked = 'nav:referrals:clicked',
  NavFaqClicked = 'nav:faq:clicked',
  NavBecomeASurferClicked = 'nav:become_a_surfer:clicked',
  NavSettingsClicked = 'nav:settings:clicked',
  NavShortTermRentalClicked = 'nav:short-term-rental:clicked',
  LandingPageHeaderCtaButtonClicked = 'landing_page:header_cta_button:clicked',
  LandingPageMobileCtaButtonClicked = 'landing_page:mobile_cta_button:clicked',
}

enum UserAccountEvents {
  ProfileUpdateFormSubmitted = 'account:form:submitted',
}

enum StripePaymentElementsEvents {
  StripePaymentDisplayed = 'Stripe Payment Displayed',
  StripePaymentSubmitError = 'Stripe Payment Submit Error',
  StripePaymentProcessError = 'Stripe Payment Processing Error',
  StripePaymentConfirmError = 'Stripe Payment Confirm Error',
  StripePaymentValidationError = 'Stripe Payment Validation Error',
  StripePaymentResubmitSuccess = 'Stripe Payment Resubmit Success',
  StripePaymentConfirmSuccess = 'Stripe Payment Confirm Success',
}

enum UnpaidBalanceEvents {
  UnpaidBalanceDisplayed = 'Unpaid Balance Displayed',
  UnpaidBalanceClicked = 'Unpaid Balance Clicked',
}

enum MerchandisingStrategy {
  BookDiscountCTAPressed = 'Book Discount CTA Clicked',
}

enum PreBookingExtension {
  PreBookingExtensionDisplayed = 'Pre Booking Extension Displayed',
  PreBookingExtensionClicked = 'Pre Booking Extension Clicked',
}

enum AffiliateEvents {
  AffiliateFormDisplayed = 'Affiliate SignUp Displayed',
  AffiliateSignUpSuccess = 'Affiliate SignUp Success',
  AffiliateSignUpError = 'Affiliate SignUp Error',
  AffiliateStripeConnectDisplayed = 'Affiliate Stripe Connect Displayed',
  AffiliateCouponCodeDisplayed = 'Affiliate Coupon Code Displayed',
  AffiliateDeactivatedDisplayed = 'Affiliate Deactivated Displayed',
}

/**
 * Ensure that all event changes are documented in the V1 tracking sheet:
 * https://docs.google.com/spreadsheets/d/1eO63qoKi2iWGPK9QXQZWzYZukkoabM3onUohIzy-jEk/edit#gid=1114892194
 */
const AnalyticsEvents = {
  AirportInstructionsEvents,
  Auth0,
  BetterInstructionsEvents,
  BookingFlow,
  EditTripEvents,
  GuestCheckout,
  CheckoutV2Events,
  CoverageBundles,
  FrontendExperiments,
  HandoverOutpostEvents,
  LiveDataSocialProofEvents,
  Priceline,
  RentalAgreements,
  Search,
  SelfPickupEvents,
  SharedTripEvents,
  InviteFriendsEvents,
  SignInEvents,
  Subscription,
  Support,
  Verification,
  TipEvents,
  TripsDetailEvents,
  Navigation,
  UserAccountEvents,
  StripePaymentElementsEvents,
  UniqueRenters,
  UnpaidBalanceEvents,
  MerchandisingStrategy,
  PreBookingExtension,
  AffiliateEvents,
};

export type AnalyticsEventsType =
  | BookingFlow
  | BetterInstructionsEvents
  | EditTripEvents
  | Subscription
  | GuestCheckout
  | SharedTripEvents
  | Priceline
  | CoverageBundles
  | RentalAgreements
  | FrontendExperiments
  | AirportInstructionsEvents
  | Auth0
  | BetterInstructionsEvents
  | BookingFlow
  | CheckoutV2Events
  | CoverageBundles
  | FrontendExperiments
  | GuestCheckout
  | HandoverOutpostEvents
  | LiveDataSocialProofEvents
  | Priceline
  | RentalAgreements
  | Search
  | SelfPickupEvents
  | SharedTripEvents
  | InviteFriendsEvents
  | SignInEvents
  | Subscription
  | Support
  | Verification
  | TipEvents
  | TripsDetailEvents
  | Navigation
  | UserAccountEvents
  | StripePaymentElementsEvents
  | UniqueRenters
  | UnpaidBalanceEvents
  | MerchandisingStrategy
  | PreBookingExtension
  | AffiliateEvents;

export const BLOCKED_POSTHOG_EVENTS: AnalyticsEventsType[] = [
  ...Object.values(LiveDataSocialProofEvents),
];

export default AnalyticsEvents;
